module.exports = __webpack_public_path__ + "img/contact-image.45b50bda.webp";